import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const HorseHeadInCircleIcon = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <defs>
        <clipPath id="cut-off-circle">
          <circle cx="16" cy="11" r="10" />
        </clipPath>
      </defs>
      <path
        d="M21.57 12.34a2.91 2.91 0 01-.27-.69c-.22-1-.37-2-.6-2.94a7.83 7.83 0 00-.85-2.34l-.05-.16a8 8 0 01.28-2.28c.06-.18.13-.36.2-.53l-1 .57c.16-.43.31-.83.46-1.25-.47.23-.95.45-1.41.7a11.69 11.69 0 00-1.3.87 13.1 13.1 0 00-1.67-.41 11.29 11.29 0 00-3.57-.07 10 10 0 00-4.27 1.25c-.23.13-.21.21 0 .18a13 13 0 012.56 0l.36.06a10.3 10.3 0 00-1.52.18 9.93 9.93 0 00-4.73 2.84c-.18.21-.13.28.11.17a13.22 13.22 0 012.58-.87 10.17 10.17 0 011.61-.18 8.76 8.76 0 00-2.94 1.19c-2.38 1.49-3.34 4.94-3.34 4.94-.08.3 0 .37.19.16 0 0 1.59-1.3 2.68-2.06a11.29 11.29 0 00-2.22 4.18 25.69 25.69 0 00-.59 3.2 2 2 0 002 2.2h11.89v-.6a7.34 7.34 0 00-.59-1.59c-.34-.8-.7-1.54-.9-1.92a7.39 7.39 0 01-.7-2.42 4.5 4.5 0 01.36-2.72c.19-.37.28-.44.53-.94.13-.26.34-.5.28-.78a2.79 2.79 0 010-1c.17.46.53 1.3.69 1.65a.37.37 0 01.06.1 4.15 4.15 0 00.42.74 4.63 4.63 0 002.16 1.78.39.39 0 01.26.35 1.28 1.28 0 001 1.33 1.73 1.73 0 00.4 0 1.55 1.55 0 001.25-.45 2.48 2.48 0 00.39-.78 2.24 2.24 0 00-.2-1.66z"
        transform="scale(-1, 1) translate(-28, 1)"
        clipPath="url(#cut-off-circle)"
      />
    </SvgIcon>
  );
};

export default HorseHeadInCircleIcon;
